/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isFeaturePresent, exportFileTitle } from '../util/CommonUtils';
import { MME_FEATUREID } from '../constants';
import MMELanding from '../components/mme/MMELanding';
import * as crosstabActions from '../actions/crosstabActions';
import * as studyActions from '../actions/studyActions';
import * as dictionaryActions from '../actions/dictionaryActions';
import NoPermissionMessage from '../components/common/NoPermissionMessage';
import NoStudyMessage from '../components/common/NoStudyMessage';
import * as mmeActions from '../actions/mmeActions';
import {
  REPORT_TYPE_SR, REPORT_TYPE_DR, REPORT_TYPE_DCR, NO_STUDY_DATA_MESSAGE,
  STATEMENT_VARIABLE_MAP_TO_LABEL,
  PAGE_VISIT_MME, ALL_ADULTS, STATEMENT_REPORT, ENGAGEMENT_SCORE_REPORT,
  ENGAGEMENT_COMPOSITION_REPORT, STATEMENT_REPORT_RUN, ENGAGEMENT_SCORE_REPORT_RUN,
  ENGAGEMENT_SCORE_COMPOSITION_REPORT_RUN, STATEMENTS, DIMENSIONS, NO_ADS_STREAMING,
} from '../components/mme/MMEConstants';
import { saveTrackingData } from '../util/trackerUtils';
import Modal from '../components/common/Modal/Modal';
import GenericButton from '../components/common/GenericButton';
import * as MMEUtils from "../util/MMEUtils";
import MMEValidateStudyModal from '../components/mme/MMEValidateStudyModal';

const validateModalStyle = {
  width: '37%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const validateMMERunModalStyle = {
  width: '37%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const validateMMERunNotRequiredModalStyle = {
  width: '37%',
  height: 'auto',
  left: '35%',
  top: '20%',
};


class MME extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBarChecked: false,
      hideWeightType: false,
      errorMessage: [],
      validData: {},
      isMediaSpecificError: '',
      isStreamingSpecificError: '',
      updatePreviousListFlag: false,
      prevListUpdated: false,
      cancelBtnClicked: false,
      weightTypeChanged: false,
    };
  }

  componentDidMount() {
    this.callSaveTrackerFn({ action: PAGE_VISIT_MME });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.mmeStudy !== this.props.mmeStudy) {
      if (!this.state.weightTypeChanged) {
        this.handleStudyChangeValidate(nextProps.mmeStudy, this.props.mmeStudy);
      }
      this.setState({ weightTypeChanged: false });
    }
    if (nextProps.mediaList && nextProps.mediaList !== this.props.mediaList
      && this.props.standardBaseLists && this.props.standardBaseLists.length === 0
      && !this.props.loginResponse.data.universityUser) {
      const fetchStandardBasetParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: nextProps.mmeStudy.pn,
      };
      this.props.mmeActions.fetchStandardBaseList(fetchStandardBasetParams);
    }
    if (nextProps.mediaList && !_.isEqual(nextProps.mediaList, this.props.mediaList)) {
      if (this.state.updatePreviousListFlag) {
        this.updatePreviousEditorData();
        this.setState({ prevListUpdated: false });
      }
    }
    if (nextProps.gridsValidationResponse && nextProps.gridsValidationResponse
      !== this.props.gridsValidationResponse) {
      this.handleValidatedData(nextProps.gridsValidationResponse);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.isEnableMMEViewer) {
      return !_.isEqual(nextProps, this.props);
    }
    return true;
  }

  updatePreviousEditorData = () => {
    this.props.mmeActions.updatePreviousSelection();
    this.setState({ updatePreviousListFlag: false });
  }

  updatePreviousSelectedData = (media, statement) => {
    const mediaList = _.cloneDeep(media);
    const statementList = _.cloneDeep(statement);
    const tempArr = [0, 1, 2, 3, 4];
    const prevMediaList = [];
    const prevStmtList = [];
    tempArr.forEach(index => {
      mediaList[index].forEach(item => {
        if (item.s === 1) {
          prevMediaList.push(item.c);
        }
      });
    });
    tempArr.forEach(index => {
      statementList[index].forEach(item => {
        if (item.s === 1) {
          prevStmtList.push(item.v);
        }
      });
    });
    this.props.mmeActions.updatePreviousSelectedData(prevMediaList, prevStmtList);
    this.setState({ prevListUpdated: true });
  }

  handleValidatedData = validatedData => {
    if (validatedData) {
      const { colList, baseList } = validatedData;
      const invalidData = {
        TargetsGrid: { selectedKeywords: [], selectedNames: [] },
        basesGrid: { selectedKeywords: [], selectedNames: [] },
      };
      const validData = {
        TargetsGrid: { selectedKeywords: [], selectedNames: [] },
        basesGrid: { selectedKeywords: [], selectedNames: [] },
      };
      if (colList.length > 0 || baseList.length > 0) {
        let invalidTargetData = [];
        let invalidBaseData = [];
        invalidTargetData = colList.filter(expression => expression.valid === false).map(expr => {
          invalidData.TargetsGrid.selectedKeywords.push(expr.expression);
          invalidData.TargetsGrid.selectedNames.push(expr.label);
          return expr;
        });
        colList.filter(expression => expression.valid === true).map(expr => {
          validData.TargetsGrid.selectedKeywords.push(expr.expression);
          validData.TargetsGrid.selectedNames.push(expr.label);
          return expr;
        });
        invalidBaseData = baseList.filter(expression => expression.valid === false).map(expr => {
          invalidData.basesGrid.selectedKeywords.push(expr.expression);
          invalidData.basesGrid.selectedNames.push(expr.label);
          return expr;
        });
        baseList.filter(expression => expression.valid === true).map(expr => {
          validData.basesGrid.selectedKeywords.push(expr.expression);
          validData.basesGrid.selectedNames.push(expr.label);
          return expr;
        });
        if (validData.TargetsGrid.selectedKeywords.length > 0 ||
          validData.basesGrid.selectedKeywords.length > 0) {
          this.setState({ validData });
        }
        if (invalidBaseData.length > 0 || invalidTargetData.length > 0) {
          this.setState({ invalidData, validData }, () => { this.validateStudyModal.show(); });
        } else if (!this.state.cancelBtnClicked) {
          this.props.mmeActions.returnToEditor();
        }
      }
    }
  };

  handleStudyChangeValidate = (study, oldStudy) => {
    const { mmeTargets, mmeBases, loginResponse, activeAccountId, mmeActions,
      mediaList, statementList, dimensionList, reportType } = this.props;
    const targetExpressionList = mmeTargets.map(expr => expr.keyword);
    const targetHeaderList = mmeTargets.map(expr => expr.title);
    const baseList = mmeBases.map(expr => expr.keyword);
    const baseHeaderList = mmeBases.map(expr => expr.title);
    if (targetExpressionList.length > 0 || baseList.length > 0) {
      if (!this.props.isEnableMMEViewer && !this.state.prevListUpdated) {
        if (reportType === 'SR') {
          this.updatePreviousSelectedData(mediaList, statementList);
        } else {
          this.updatePreviousSelectedData(mediaList, dimensionList);
        }
      }
      const params = {
        uid: loginResponse.data.uid,
        accountId: activeAccountId,
        productNo: study.pn,
        weightType: this.props.mmeWeightTypes.wt,
        divisor: this.props.mmeWeightTypes.dv,
        baseList,
        baseHeaderList,
        targetExpressionList,
        targetHeaderList,
        oldStudy,
      };
      mmeActions.validateBaseTargetdata(params);
    } else if (this.props.isEnableMMEViewer) {
      this.props.mmeActions.returnToEditor();
      this.props.mmeActions.resetMMEToDefault();
    }
  }

  getDataForSampleWeighted = (validData, sampleWeightedParams, targetGrid, gridType) => {
    const { gridsValidationResponse, sampleWeightedKPIs, mmeActions } = this.props;
    sampleWeightedParams = {
      ...sampleWeightedParams,
      sourceGrid: targetGrid,
      targetGrid,
      expressionList: validData[gridType].selectedKeywords,
      selectedNames: validData[gridType].selectedNames,
      oldStudy: gridsValidationResponse.oldStudy,
    };
    let kpiNotExistsFlag = false;
    const responseData = [];
    validData[gridType].selectedKeywords.forEach(elems => {
      if (sampleWeightedKPIs[elems] === undefined) {
        kpiNotExistsFlag = true;
      } else {
        responseData.push(sampleWeightedKPIs[elems].data[0]);
      }
    });
    if (kpiNotExistsFlag) {
      mmeActions.getSampleWeighted(sampleWeightedParams);
    } else {
      sampleWeightedParams.response = responseData;
      mmeActions.getSampleWeightedData(sampleWeightedParams);
    }
  }

  handleValidateContinueBtnClick = () => {
    const { validData } = this.state;
    const { loginResponse, activeAccountId, mmeStudy, mmeActions } = this.props;
    const sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      productNo: mmeStudy.pn,
      weightType: this.props.mmeWeightTypes.wt,
      divisor: this.props.mmeWeightTypes.dv,
    };
    if (validData.TargetsGrid.selectedKeywords.length > 0) {
      this.getDataForSampleWeighted(validData, sampleWeightedParams, 'TargetsDataGrid', 'TargetsGrid');
    } else {
      mmeActions.resetGridData('TargetsDataGrid');
    }
    if (validData.basesGrid.selectedKeywords.length > 0) {
      this.getDataForSampleWeighted(validData, sampleWeightedParams, 'BasesDataGrid', 'basesGrid');
    } else {
      mmeActions.resetGridData('BasesDataGrid');
    }
    this.props.mmeActions.resetMMEToDefault();
    this.props.mmeActions.returnToEditor();
    this.setState({ cancelBtnClicked: false });
    this.validateStudyModal.hide();
  }

  handleValidateCancelBtnClick = () => {
    const gridsValidationResponse = _.cloneDeep(this.props.gridsValidationResponse);
    const { studyActions } = this.props;
    studyActions.updateModuleStudy('mme', gridsValidationResponse.oldStudy);
    this.validateStudyModal.hide();
    this.setState({ updatePreviousListFlag: true, cancelBtnClicked: true });
  }

  onChangeProperty = (dimensionType, list, e, stmtList) => {
    this.props.mmeActions.onChangeProperty(dimensionType, list, e, stmtList);
  };

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    BasesDataGrid: this.props.mmeBases,
    TargetsDataGrid: this.props.mmeTargets,
    RecycleElements: this.props.recycleElements,
  });

  getCodes = (list, listName, needNWInfo) => {
    const mediatList = list;
    const codes = [];
    const items = [0, 1, 2, 3, 4];
    items.forEach(item => {
      mediatList[item].forEach(code => {
        if (listName === 'media' && code.s === 1) {
          if (needNWInfo) {
            if (code.c.substring(0, 1) === 'T') {
              codes.push({ code: code.c, nw: code.nw });
            }
          } else {
            codes.push(code.c);
          }
        } else if (listName === 'statement' && code.s === 1) {
          codes.push(code.v);
        }
      });
    });
    return codes;
  }

  getPrefixName = (list, listName) => {
    const mediatList = list;
    const names = [];
    const items = [0, 1, 2, 3, 4];
    items.forEach(item => {
      mediatList[item].forEach(code => {
        if (listName === 'media' && code.s === 1) {
          names.push(code.c.substring(0, 1));
        } else if (listName === 'statement' && code.s === 1) {
          names.push(
            code.n.substring(code.n.indexOf('(') + 1, code.n.indexOf(')'))
          );
        }
      });
    });
    return names;
  }

  getColorValue = list => {
    const statementList = list;
    const colorValue = [];
    const items = [0, 1, 2, 3, 4];
    items.forEach(item => {
      statementList[item].forEach(code => {
        if (code.s === 1) {
          colorValue.push(code.cv);
        }
      });
    });
    return colorValue;
  }

  getStatementVariableLabel = statementList => {
    const statementLabel = [];
    if (statementList.length > 0) {
      statementList.forEach(stmt => {
        statementLabel.push(STATEMENT_VARIABLE_MAP_TO_LABEL[stmt]);
      });
    }
    return statementLabel.join(', ');
  }

  getLabels = (list, listName) => {
    const mediatList = list;
    const labels = [];
    const items = [0, 1, 2, 3, 4];
    items.forEach(item => {
      mediatList[item].forEach(code => {
        if (listName === 'media' && code.s === 1) {
          labels.push(code.n);
        } else if (listName === 'statement' && code.s === 1) {
          labels.push(code.n);
        }
      });
    });
    return labels;
  };

  getReportParams = (activeTarget, activeBase) => {
    const { mmeStudy, reportType, mmeTargets, mmeBases, standardBaseLists,
      mediaList, statementVariableSelected,
      statementList, dimensionList, mmeDefaultTargetList, selectedBase } = this.props;
    const productNo = mmeStudy.pn;
    const title = 'A MME Report';
    let base = selectedBase;
    let baseDescriptionStr;
    if (activeBase !== undefined) {
      base = activeBase;
    }
    let baseFlag = false;
    if (base === 'StudyUniverseKey') {
      baseFlag = true;
      baseDescriptionStr = 'StudyUniverse';
    }
    if (!baseFlag) {
      const baseDescriptionFind = mmeBases.find(e => {
        return e.keyword === base;
      });
      baseDescriptionStr = _.isEmpty(baseDescriptionFind) ? '' : baseDescriptionFind.title;
    }

    if (!baseDescriptionStr) {
      const baseDescriptionFind = standardBaseLists.find(e => {
        return e.expression === base;
      });
      baseDescriptionStr = _.isEmpty(baseDescriptionFind) ? '' : (baseDescriptionFind.label).split(' ').join('');
    }
    const baseDescription = (baseDescriptionStr.replace(/ {2,}/g, '').trim()).replace(/[^A-Z0-9]+/ig, '_');
    const targets = [activeTarget];
    const targetDescs = [activeTarget];
    const weightType = this.props.mmeWeightTypes.wt;
    const divisor = this.props.mmeWeightTypes.dv;
    const selectedWeightName = this.props.mmeWeightTypes.wn;
    const vehicleCodes = mediaList ? this.getCodes(mediaList, 'media') : [];
    let statementVariables = statementVariableSelected || [];
    const statementVariableLabel = statementVariableSelected ?
      this.getStatementVariableLabel(statementVariableSelected) : '';
    const scoreList = statementList ?
      this.getCodes(reportType === REPORT_TYPE_SR ? statementList : dimensionList, 'statement') : [];
    const scoreListColorValue = statementList ?
      this.getColorValue(reportType === REPORT_TYPE_SR ? statementList : dimensionList, 'statement') : [];
    const mmeTargetList = mmeTargets && mmeTargets.length > 0
                          ? mmeDefaultTargetList.concat(mmeTargets.map(({ title, keyword }) =>
                          ({ title, keyword }))) : mmeDefaultTargetList;
    if (reportType !== REPORT_TYPE_SR) {
      statementVariables = undefined;
    }
    const vehicleNames = mediaList ? this.getPrefixName(mediaList, 'media') : [];
    const statementNames = statementList ?
      this.getPrefixName(reportType === REPORT_TYPE_SR ? statementList : dimensionList, 'statement') : [];
    const tvVehicleCodesWithNWInfo = mediaList ? this.getCodes(mediaList, 'media', true) : [];

    return {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo,
      title,
      reportType,
      targets,
      targetDescs,
      weightType,
      divisor,
      selectedWeightName,
      vehicleCodes,
      statementVariables,
      scoreList,
      statementVariableLabel,
      scoreListColorValue,
      mmeTargetList,
      base,
      baseDescription,
      activeTarget,
      vehicleNames,
      statementNames,
      tvVehicleCodesWithNWInfo,
      fileName: exportFileTitle('MME'),
    };
  };

  callSaveTrackerFn = ({ action, attributes = undefined }) => {
    const productNo = this.props.mmeStudy !== undefined ?
      this.props.mmeStudy.pn : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: 'MME',
      attributes,
      action,
    });
  }

  handleSelect = e => {
    this.props.mmeActions.updateSelectedMediaVehicle(e);
  };

  updateSelectedAction = selectedItems => {
    this.props.mmeActions.updateStatementVariables(selectedItems);
  };

  updateReportTypeAction = type => {
    this.props.mmeActions.updateReportType(type);
  }

  updateDimensionType = type => {
    this.props.mmeActions.updateDimensionType(type);
  }

  checkIfNonAdVehicleOrStatement = (mediaLabels, statementLabels) => {
    const noAdStreaming = [];
    const gAStatement = [];
    const adStatement = [];
    mediaLabels.forEach(item => {
      if (NO_ADS_STREAMING.includes(item)) {
        noAdStreaming.push(item)
      }
    })
    statementLabels.forEach(item => {
      if (item.includes('(GA)')) {
        gAStatement.push(item);
      }
      if (item.includes('Ad ') || item.includes('AD ')) {
        adStatement.push(item)
      }
    });
    return {
      noAdStreaming,
      gAStatement,
      adStatement,
    }
  };

  validateParams = (params, reportType) => {
    let errMsg = [];
    const { mmeStudy, mediaList, dimensionList, statementList } = this.props;
    const mediaLabels = this.getLabels(mediaList, 'media');
    const statementLabels = this.getLabels(
      reportType === REPORT_TYPE_SR ? statementList : dimensionList,
      'statement'
    );
    const nonAdVehicleAndAdStatement =
      mmeStudy.ss === "MRI" &&
      this.checkIfNonAdVehicleOrStatement(mediaLabels, statementLabels);
    errMsg =
      reportType === REPORT_TYPE_SR
        ? MMEUtils.mmeSReportRunValidationMessage(
            params,
            mmeStudy,
            nonAdVehicleAndAdStatement
          )
        : MMEUtils.mmeEReportRunValidationMessage(
            params,
            mmeStudy,
            nonAdVehicleAndAdStatement
          );
    return errMsg;
  }

  getActiveTraget = (activeTarget, newTargetAdded) => {
    const { mmeAllTargetsTableList, mmeTargets, mmeDefaultTargetList } = this.props;

    let validActiveTarget = activeTarget;

    const mmeTargetList = mmeTargets && mmeTargets.length > 0
    ? mmeDefaultTargetList.concat(mmeTargets.map(({ title, keyword }) =>
    ({ title, keyword }))) : mmeDefaultTargetList;

    const mmeTargetKeywords = mmeTargetList.map(item => item.keyword);

    if (newTargetAdded) {
      validActiveTarget = ALL_ADULTS;
    } else if (!mmeTargetKeywords.includes(activeTarget)) {
      validActiveTarget = ALL_ADULTS;
    } else {
      Object.keys(mmeAllTargetsTableList).forEach(key => {
        if (!mmeTargetKeywords.includes(key)) {
          if ((mmeTargetKeywords.length === 1 && mmeTargetKeywords[0] === ALL_ADULTS)
            || newTargetAdded) {
            validActiveTarget = ALL_ADULTS;
          } else {
            validActiveTarget = activeTarget === key ? ALL_ADULTS : activeTarget;
          }
        }
      });
    }

    return validActiveTarget;
  }

  exportMMEReport = () => {
    const activeTarget = this.props.landingTarget;
    const params = this.getReportParams(activeTarget);
    this.props.mmeActions.exportMME(params);
  }

  runMMEReport = (activeTarget, RUN_CLICKED, activeBase) => {
    const { mmeAllTargets, mmeTargets, mmeAllTargetsTableList,
      reportType, isEnableMMEViewer, prevMMEBase, selectedBase } = this.props;

    const prevMMEAllTargets = mmeAllTargets.filter(item => item.keyword !== ALL_ADULTS)
      .map(({ title, keyword }) => ({ title, keyword }));

    const prevMMETargets = mmeTargets.map(({ title, keyword }) => ({ title, keyword }));

    const newTargetAdded = (prevMMETargets.length > prevMMEAllTargets.length);

    let currentBase = selectedBase;

    if (activeBase !== undefined) {
      currentBase = activeBase;
    }
    if (
      isEnableMMEViewer
      && activeTarget in mmeAllTargetsTableList
      && _.isEqual(_.sortBy(prevMMEAllTargets), _.sortBy(prevMMETargets))
      && prevMMEBase === currentBase
      && selectedBase === 'StudyUniverseKey'
    ) {
      // if (RUN_CLICKED) {
      //   this.validateMMERunNotRequired.show();
      // }
      this.props.mmeActions.updateMMETabGridData(activeTarget);
    } else {
      const validActiveTarget = this.getActiveTraget(activeTarget, newTargetAdded);
      const params = this.getReportParams(validActiveTarget, activeBase);
      const validationMsg = this.validateParams(params, reportType);
      this.setState(
        {
          errorMessage: validationMsg.errMsg,
          isMediaSpecificError: validationMsg.isMediaSpecificError,
          isStreamingSpecificError: validationMsg.isStreamingSpecificError
        });
      if (validationMsg && validationMsg.errMsg.length > 0 &&
        Object.keys(validationMsg).length > 0) {
        this.validateMMERunModal.show();
      } else {
        let action = '';
        switch (reportType) {
          case REPORT_TYPE_SR: action = STATEMENT_REPORT_RUN; break;
          case REPORT_TYPE_DR: action = ENGAGEMENT_SCORE_REPORT_RUN; break;
          case REPORT_TYPE_DCR: action = ENGAGEMENT_SCORE_COMPOSITION_REPORT_RUN; break;
          default: action = ''; break;
        }
        if (action !== '') {
          this.callSaveTrackerFn(
            {
              action,
              attributes:
              {
                Television: params.vehicleNames.filter(str => str === 'T').length,
                Internet: params.vehicleNames.filter(str => str === 'I').length,
                Magazine: params.vehicleNames.filter(str => str === 'M').length,
              },
            }
          );
        }
        this.props.mmeActions.runMME(params);
      }
    }
  }

  clearCrossTabData = () => {
    const { crosstabActions } = this.props;
    crosstabActions.addDDNHCSData([]);
    crosstabActions.clearSampleWeightedKPIs();
  }

  returnToEditor = () => {
    this.props.mmeActions.returnToEditor();
  }

  updateWeightType = (updatedStudy, updatedWeightType) => {
    const { studyActions, dictionaryActions } = this.props;
    studyActions.updateModuleStudy('mme', updatedStudy, updatedWeightType);
    dictionaryActions.clearTreeLoadNodeList();
  }

  runReportAfterWeightChange = wt => {
    const activeTarget = this.props.landingTarget;
    const params = this.getReportParams(activeTarget);
    params.weightType = wt;
    this.setState({ weightTypeChanged: true }, () => {
      if (this.props.mmeAllTargets && this.props.mmeAllTargets.length > 1) {
        this.props.mmeActions.clearTargets(this.props.landingTarget);
      }
      this.props.mmeActions.runMME(params);
    });
  }

  handleStudyChange = (val, updatedWeightType) => {
    this.clearCrossTabData();

    const updatedStudy = {
      ...val,
      wt: 1,
    };
    if (this.props.mediaList && this.props.mediaList[4].length && this.props.selectedMediaVehicleIndex === 4) {
      this.props.mmeActions.updateSelectedMediaVehicle(0);
    }
    if (this.props.mediaList && this.props.mediaList[4].length && this.props.selectedDimensionType === 4) {
      this.updateDimensionType(0);
    }
    this.updateWeightType(updatedStudy, updatedWeightType);
  }

  handlesideBarToggle = () => {
    this.setState((prevState) => ({ sideBarChecked: !prevState.sideBarChecked }));
  }

  renderErrorMessage = errorMessage => {
    if (errorMessage.length > 0) {
      return (
        <Fragment>
          {errorMessage.map(err => (
            <li key={uuid()}>{`${err}`}</li>
          ))}
        </Fragment>
      );
    }

    return <div />;
  };

  renderNoEssentialStudiesMessage = () => {
    const { hasModuleAccess, hasMMEStudies } = this.props;
    if (!hasModuleAccess) {
      return <NoPermissionMessage />;
    }
    if (hasModuleAccess && !hasMMEStudies) {
      return (
        <NoStudyMessage message={NO_STUDY_DATA_MESSAGE} />
      );
    }
    return null;
  }

  renderMME = () => {
    const {
      hasModuleAccess,
      studies,
      crosstabActions,
      studyActions,
      hasMMEStudies,
      isEnableMMEViewer,
      mediaList,
      statementList,
      dimensionList,
      selectedDimensionType,
      selectedReportType,
      statementVariableSelected,
      selectedMediaVehicleIndex,
      statementVariableLabel,
      reportType,
      mmeAllTargets,
      landingTarget,
    } = this.props;
    const { sideBarChecked, hideWeightType } = this.state;
    if (hasModuleAccess && hasMMEStudies) {
      return (
        <div>
          <MMELanding
            data-test="RenderMMEFunc"
            studies={studies}
            mmeStudy={this.props.mmeStudy}
            getSampleWeighted={this.props.mmeActions.getSampleWeighted}
            removeKPI={crosstabActions.removeCrossTabKpiInfo}
            fetchKPI={crosstabActions.fetchKPI}
            gridData={this.getGridData()}
            handlesideBarToggle={this.handlesideBarToggle}
            sideBarChecked={sideBarChecked}
            updateModuleStudy={studyActions.updateModuleStudy}
            hideWeightType={hideWeightType}
            handleStudyChange={this.handleStudyChange}
            runMMEReport={this.runMMEReport}
            exportMMEReport={this.exportMMEReport}
            returnToEditor={this.returnToEditor}
            isEnableMMEViewer={isEnableMMEViewer}
            handleSelect={this.handleSelect}
            updateSelectedAction={this.updateSelectedAction}
            mediaList={mediaList}
            statementList={statementList}
            dimensionList={dimensionList}
            updateReportTypeAction={this.updateReportTypeAction}
            updateDimensionType={this.updateDimensionType}
            selectedDimensionType={selectedDimensionType}
            onChangeProperty={this.onChangeProperty}
            selectedReportType={selectedReportType}
            statementVariableSelected={statementVariableSelected}
            selectedMediaVehicleIndex={selectedMediaVehicleIndex}
            statementVariableLabel={statementVariableLabel}
            mmeAllTargets={mmeAllTargets}
            reportType={reportType}
            trackerFn={this.callSaveTrackerFn}
            landingTarget={landingTarget}
            landingIndex={mmeAllTargets.findIndex(tabItem => tabItem.keyword === landingTarget)}
            vehicleCodeCount={mediaList ? this.getCodes(mediaList, 'media').length : 0}
            runReportAfterWeightChange={this.runReportAfterWeightChange}
          />
          <Modal
            title={(!this.state.isMediaSpecificError && !this.state.isStreamingSpecificError) ?
              'Run not successful' : 'Selection(s) not compatible'}
            ref={node => (this.validateMMERunModal = node)}
            dialogStyles={validateMMERunModalStyle}
          >
            {(!this.state.isMediaSpecificError && !this.state.isStreamingSpecificError) &&
              <div>
                {reportType === REPORT_TYPE_SR &&
                  <h4>
                    Minimum selection requirements must be met to run {STATEMENT_REPORT}
                  </h4>}
                {reportType === REPORT_TYPE_DR &&
                  <h4>
                    Minimum selection requirements must be met to run {ENGAGEMENT_SCORE_REPORT}
                  </h4>}
                {reportType === REPORT_TYPE_DCR &&
                  <h4>
                    Minimum selection requirements must be met to
                    run {ENGAGEMENT_COMPOSITION_REPORT}
                  </h4>}
                <h4>Please modify selections to meet the following conditions:</h4>
              </div>
            }
            {this.state.isMediaSpecificError &&
              <div>
                {reportType === REPORT_TYPE_SR &&
                  <h4>
                    Analyses with only media-specific {STATEMENTS} selected can only
                    contain property selections from within a compatible media vehicle.
                  </h4>}
                {reportType === REPORT_TYPE_DR &&
                  <h4>
                    Analyses with only media-specific {DIMENSIONS} selected can only
                    contain property selections from within a compatible media vehicle.
                  </h4>}
                {reportType === REPORT_TYPE_DCR &&
                  <h4>
                    Analyses with only media-specific {DIMENSIONS} selected can only
                    contain property selections from within a compatible media vehicle.
                  </h4>}
                <h4>Please modify current media vehicles selections to run analysis:</h4>
              </div>
            }
            {this.state.isStreamingSpecificError && 
              <div>
                <h4>
                  You’ve selected a network or streaming service that has no advertising.
                </h4>
                <h4>Please modify current media vehicle selections to run analysis by either:</h4>
              </div>
            }
            <ul className="run-msg-modal">
              {this.renderErrorMessage(this.state.errorMessage)}
            </ul>
            <GenericButton
              name="OK"
              btnStyle="button btn-cncl float-right margin-right-10"
              onBtnClick={() => this.validateMMERunModal.hide()}
            />
          </Modal>
          <Modal
            title="Run not required"
            ref={node => (this.validateMMERunNotRequired = node)}
            dialogStyles={validateMMERunNotRequiredModalStyle}
          >
            <h4>No change in the data point, Please modify selections to run the report.</h4>
            <div>
              Exising data for the active target will be updated.
            </div>
            <GenericButton
              name="OK"
              btnStyle="button btn-cncl float-right margin-right-10"
              onBtnClick={() => this.validateMMERunNotRequired.hide()}
            />
          </Modal>
          <Modal
            title={this.props.isEnableMMEViewer ? 'Redirect to Editor' : 'Data points can\'t be transferred'}
            ref={node => (this.validateStudyModal = node)}
            dialogStyles={validateModalStyle}
            closeTracker={() => this.handleValidateCancelBtnClick()}
          >
            <div>
              <MMEValidateStudyModal
                handleCancelClick={() => this.handleValidateCancelBtnClick()}
                handleContinueClick={() => this.handleValidateContinueBtnClick()}
                moduleStudy={this.props.mmeStudy}
                invalidData={this.state.invalidData}
                mmeViewer={this.props.isEnableMMEViewer}
              />
            </div>
          </Modal>
        </div>
      );
    }
    return null;
  }


  render() {
    return (
      <div className="test-class">
        {this.renderNoEssentialStudiesMessage()}
        {this.renderMME()}
      </div>
    );
  }
}

MME.propTypes = {
  hasModuleAccess: PropTypes.bool,
  hasMMEStudies: PropTypes.bool,
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    clearTreeLoadNodeList: PropTypes.func,
  }),
  mmeStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  studies: PropTypes.instanceOf(Array),
  // weightTypeStudies: PropTypes.instanceOf(Array),
  kpiInfo: PropTypes.shape({}),
  mmeBases: PropTypes.arrayOf(PropTypes.object),
  mmeTargets: PropTypes.arrayOf(PropTypes.object),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  activeAccountId: PropTypes.number,
  mmeActions: PropTypes.shape({
    runMME: PropTypes.func,
    returnToEditor: PropTypes.func,
    updateSelectedMediaVehicle: PropTypes.func,
    updateStatementVariables: PropTypes.func,
    updateReportType: PropTypes.func,
    updateDimensionType: PropTypes.func,
    onChangeProperty: PropTypes.func,
    getSampleWeighted: PropTypes.func,
    fetchStandardBaseList: PropTypes.func,
    updateMMETabGridData: PropTypes.func,
    exportMME: PropTypes.func,
    updatePreviousSelectedData: PropTypes.func,
    updatePreviousSelection: PropTypes.func,
    resetMMEToDefault: PropTypes.func,
    clearTargets: PropTypes.func,
    validateBaseTargetdata: PropTypes.func,
    resetGridData: PropTypes.func,
    getSampleWeightedData: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
      universityUser: PropTypes.bool,
    }),
  }),
  isEnableMMEViewer: PropTypes.bool,
  mediaList: PropTypes.shape({}),
  statementList: PropTypes.shape({}),
  dimensionList: PropTypes.shape({}),
  selectedDimensionType: PropTypes.number,
  selectedReportType: PropTypes.string,
  statementVariableSelected: PropTypes.instanceOf(Array),
  selectedMediaVehicleIndex: PropTypes.number,
  statementVariableLabel: PropTypes.string,
  reportType: PropTypes.string,
  mmeDefaultTargetList: PropTypes.instanceOf(Array),
  crosstabActions: PropTypes.shape({
    fetchKPI: PropTypes.func,
    removeCrossTabKpiInfo: PropTypes.func,
    clearSampleWeightedKPIs: PropTypes.func,
    addDDNHCSData: PropTypes.func,
  }),
  standardBaseLists: PropTypes.instanceOf(Array),
  mmeAllTargets: PropTypes.instanceOf(Array),
  mmeAllTargetsTableList: PropTypes.shape({}),
  landingTarget: PropTypes.string,
  prevMMEBase: PropTypes.string,
  selectedBase: PropTypes.string,
  gridsValidationResponse: PropTypes.shape({}),
  sampleWeightedKPIs: PropTypes.shape({}),
  mmeWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.string,
  }),
};

MME.defaultProps = {
  hasMMEStudies: true,
  hasModuleAccess: false,
};

function mapStateToProps(state) {
  return {
    hasModuleAccess: isFeaturePresent(MME_FEATUREID, state.userDetail.permissions),
    hasMMEStudies: state.study.hasMMEStudies,
    studies: state.study.studies,
    mmeStudy: state.study.mmeStudy,
    // weightTypeStudies: state.study.weightTypeStudies,
    kpiInfo: state.crosstab.kpiInfo,
    mmeBases: state.mme.BasesDataGridData,
    mmeTargets: state.mme.TargetsDataGridData,
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    reportType: state.mme.reportType,
    isEnableMMEViewer: state.mme.isEnableMMEViewer,
    mediaList: state.mme.mediaList,
    statementList: state.mme.statementList,
    dimensionList: state.mme.dimensionList,
    selectedDimensionType: state.mme.dimensionType,
    selectedReportType: state.mme.reportType,
    statementVariableSelected: state.mme.statementVariableSelected,
    selectedMediaVehicleIndex: state.mme.selectedMediaVehicleIndex,
    statementVariableLabel: state.mme.statementVariableLabel,
    mmeDefaultTargetList: state.mme.mmeDefaultTargetList,
    standardBaseLists: state.mme.standardBaseLists,
    mmeAllTargets: state.mme.mmeAllTargets,
    mmeAllTargetsTableList: state.mme.mmeAllTargetsTableList,
    landingTarget: state.mme.landingTarget,
    prevMMEReportType: state.mme.prevMMEReportType,
    prevMMEBase: state.mme.prevMMEBase,
    selectedBase: state.mme.selectedBase.selectedBaseNode,
    gridsValidationResponse: state.mme.gridsValidationResponse,
    sampleWeightedKPIs: state.mme.sampleWeightedKPIs,
    mmeWeightTypes: state.study.mmeWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    mmeActions: bindActionCreators(mmeActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MME);
